document.addEventListener("DOMContentLoaded", () => {
  const drawer = document.querySelector(".drawer-menu__panel");
  const backdrop = document.querySelector(".drawer-menu__backdrop");
  const body = document.body;

  // Fonction pour ouvrir le drawer
  function openDrawer() {
    if (drawer && backdrop) {
      drawer.classList.add("active");
      backdrop.classList.add("active");
      body.style.overflow = "hidden";
    }
  }

  // Fonction pour fermer le drawer (utile si tu veux un lien "fermer" ailleurs)
  function closeDrawer() {
    if (drawer && backdrop) {
      drawer.classList.remove("active");
      backdrop.classList.remove("active");
      body.style.overflow = "";
    }
  }

  // Liens qui ouvrent le drawer : ajoute la classe open-drawer-link à ton <a>
  document.body.addEventListener("click", (e) => {
    const link = e.target.closest(".open-drawer-link");
    if (link) {
      e.preventDefault();
      openDrawer();
    }
  });

  // Garde les événements existants pour fermer le drawer
  const closeBtn = document.querySelector(".drawer-menu__close");
  if (closeBtn) {
    closeBtn.addEventListener("click", closeDrawer);
  }
  if (backdrop) {
    backdrop.addEventListener("click", closeDrawer);
  }
});
